import { Skeleton } from "antd";
import { usePermissao } from "../../uteis/permissaoAdm/usePermissao";
import { Container, ContainerTitulo, TituloForm } from "./styles";
import Globais from "../../components/Globais";

export default function ViewGerenciar() {
   const { isLoading } = usePermissao("OPE");
    
      
  

  return (
    <>
      {isLoading ? (
        <Skeleton active />
      ) : (
        <Container>
          <ContainerTitulo>
            <TituloForm>Configurações</TituloForm>
          </ContainerTitulo>
          
          <main className="card-grid">
            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-cogs"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Configurações do Sistema</h2>
              <p>Gerencie os parâmetros gerais e limites globais do sistema.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarConfigSistema"}>Acessar</a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-map-marker-alt"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Estado</h2>
              <p>Gerencie os estados cadastrados para os empreendimentos.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarEstado"}>Acessar</a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-city"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Cidade</h2>
              <p>Controle e edite as cidades relacionadas aos estados.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarCidade"}>Acessar</a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-building"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Empreendimento</h2>
              <p>
                Cadastro e edição de empreendimentos disponíveis no sistema.
              </p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarEmpreendimento"}>
                Acessar
              </a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-door-closed"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Apartamento</h2>
              <p>
                Gerencie informações dos apartamentos vinculados a cada
                empreendimento.
              </p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarApto"}>Acessar</a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-users"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Usuários</h2>
              <p>Controle e gerencie os usuários com acesso ao sistema.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarUsuarios"}>Acessar</a>
            </div>

            <div className="card">
              <div style={{ textAlign: "center" }}>
                <i
                  className="fas fa-handshake"
                  style={{
                    fontSize: "2rem",
                    marginBottom: "1rem",
                    color: "#003644",
                  }}
                ></i>
              </div>
              <h2>Parceiros</h2>
              <p>Controle e gerencie os parceiros do sistema.</p>
              <a href={Globais.DOMINIOFRONT + "/gerenciarParceiros"}>Acessar</a>
            </div>
          </main>
        </Container>
      )}
      ;
    </>
  );
}
